<mat-card appearance="outlined">
  <mat-card-content>
    <div class="mainBody">
      <p class="text-center fw-bold mb-4">Editar Proyecto a la factura simplificada</p>

      <ng-container *ngIf="!ready">
        <div class="text-center my-4">
          <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
        </div>
      </ng-container>

      <ng-container *ngIf="ready">
        <div class="row justify-content-center">
          <div class="col-10">
            <app-autocomplete-select [items]="projects" [(selectedItemId)]="ticket.projectUid" [idField]="'id'"
              [displayField]="'display'" placeholder="Proyecto" class="w-100">
            </app-autocomplete-select>

          </div>
        </div>
      </ng-container>
    </div>
  </mat-card-content>

  <mat-card-actions align="end" class="px-3 pb-3 pt-3">
    <button mat-stroked-button class="me-2" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
      Cerrar
    </button>
    <button mat-stroked-button class="btn-convfact" (click)="save()" [disabled]="!ready || !ticket.projectUid">
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  </mat-card-actions>
</mat-card>
